// eslint:disable variable-name
import * as React from 'react';
import { Button } from './button';
import { MdClose } from 'react-icons/md';
import styles from './close-button.scss';

export interface CloseButtonProps {
  onClick: (event: any) => void;
  autofocus?: boolean;
  tabIndex?: number;
  disabled?: boolean;
}

export class CloseButton extends React.PureComponent<CloseButtonProps> {
  public static defaultProps: Partial<CloseButtonProps> = {
    autofocus: true,
    disabled: false
  };

  public render() {

    return (
      <Button btnType={styles.closeButton} onClick={this.props.onClick} autoFocus={this.props.autofocus} tabIndex={this.props.tabIndex}
        disabled={this.props.disabled}>
        {/* Needs translation? */}
        <span className="visuallyhidden">Close</span>
        <MdClose />
      </Button>
    );
  }
}
